import styled from 'styled-components/macro';
import useLogo from '../Hooks/useLogo';
import { useMediaQuery } from 'react-responsive';
import UspBanner from './usp-banner';

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.colors.header.desktop.backgroundColor};
  align-items: flex-start;
  height: ${(props) => props.theme.header.height.desktop};
  padding: 20px 0;
  margin-bottom: 32px;
  filter: drop-shadow(0 0 1px #000);

  @media screen and (max-width: 767px) {
    position: fixed;
    width: 100%;
    align-items: center;
    height: ${(props) => props.theme.header.height.mobile};
    background-color: ${(props) => props.theme.colors.header.mobile.backgroundColor};
    z-index: 100;
    padding: 0;
  }
`;

const Container = styled.div`
  display: grid;
  justify-content: start;
  grid-template-columns: min-content 1fr;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  height: 100%;
  padding: 0 40px;

  @media screen and (max-width: 767px) {
    justify-content: start;
    height: 100%;
    padding: 12px 2.5%;
  }
`;

interface HeaderProps {
  uspBannerEntries: { text: string }[] | undefined;
}

const Header = (props: HeaderProps) => {
  const Logo = useLogo();
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const uspBannerCount = props.uspBannerEntries?.length ?? 0;

  const showLogo = !isMobile || uspBannerCount === 0;

  const logoProps: React.SVGProps<SVGSVGElement> = {
    height: isMobile ? '30px' : '45px',
  };

  return (
    <HeaderWrapper>
      <Container>
        {showLogo && <Logo {...logoProps} />}

        <UspBanner uspBannerEntries={props.uspBannerEntries} />
      </Container>
    </HeaderWrapper>
  );
};

export default Header;
